import {apolloProvider} from "../main"
import gql from "graphql-tag";
// import axios from "axios";

// const NODE_ENV = process.env.NODE_ENV;
// const SSO_URL =
//   NODE_ENV === "development"
//     ? "http://hoadev.ddns.net:30004/"
//     : process.env.VUE_APP_SSO_URL;

// const { VUE_APP_AUTH_TOKEN_NAME, VUE_APP_GRAPHQL_HTTP } = process.env;
const queryRefresh = gql`
  query { refreshMsToken }
`;

export default () => {
  // const ictToken = localStorage.getItem(VUE_APP_AUTH_TOKEN_NAME);
  // return axios({
  //   method: "post",
  //   url: VUE_APP_GRAPHQL_HTTP,
  //   headers: {
  //     Authorization: "Bearer " + ictToken,
  //   },
  //   data: { query: queryRefresh },
  // });

  if(apolloProvider?.defaultClient){
    return apolloProvider.defaultClient
      .query({
        query: queryRefresh,
        fetchPolicy: "no-cache",
      })
  } else {
    return ""
  }

};
